module.exports = __webpack_public_path__ + "img/meal-icon-generic.de1a4137.svg";